const resourceBaseUrl = 'https://api.platform.eidu.com/resources'

export default resourceBaseUrl
